/* eslint-disable import/no-cycle */
import { GtmConstants } from './GtmConstants';
import { LocationHelper } from './LocationHelper';
import { StorageHelper } from './StorageHelper';

/* eslint-disable import/prefer-default-export */
const EQ = '=' as string;
const UTM_CAP = 'UTM' as string;
const UTM = 'utm' as string;

export class UtmManager {
  static EMAIL_BIENVENIDA = 'e_bienvenida';

  static getPathWithUtms = (params: {}) => {
    const keys = Object.keys(params);
    let searchParams = '';
    keys.forEach((key: string) => {
      if (key.includes(UTM_CAP) || key.includes(UTM)) {
        searchParams = searchParams
          .concat(key)
          .concat(EQ)
          .concat((params as any)[key])
          .concat('&');
      }
    });
    searchParams = searchParams.substring(0, searchParams.lastIndexOf('&'));
    return searchParams !== ''
      ? window.location.pathname.concat('?').concat(searchParams)
      : window.location.pathname;
  };

  static getUtmCampaing = () => {
    const paramsUrl = LocationHelper.getParametersFromUrl();
    if (paramsUrl?.utm_campaign) {
      return paramsUrl.utm_campaign;
    }
    return '';
  };

  static setAltaOroAttributesForUtmCampaign = (campaign: string) => {
    if (campaign === UtmManager.EMAIL_BIENVENIDA) {
      StorageHelper.setNoroLabel(GtmConstants.EB_LABEL);
      StorageHelper.setOpenFormOro();
    }
  };
}
/* eslint-enable import/no-cycle */
